import PropTypes from "prop-types"
import { forwardRef } from "react"

import Button from "components/ui/button"
import { cn } from "styles/utils"

export const SizeBox = ({
  availableHoliday = false,
  className = "",
  ...props
}) => (
  <Button
    className={cn("size-box", className)}
    data-available-holiday={availableHoliday}
    {...props}
  />
)

SizeBox.propTypes = {
  availableHoliday: PropTypes.bool,
  className: PropTypes.string,
}

export const SizeBoxSmall = ({
  as: Component = "div",
  className,
  selected = false,
  ...props
}) => (
  <Component
    className={cn(
      "text-neutral text-12 mr-15 ml-4 flex size-40 items-center justify-center rounded-full border bg-white font-medium leading-9 transition-all duration-300 ease-in",
      selected
        ? "ring-3 ring-selected border-selected"
        : "border-grey-65 shadow-none",
      className
    )}
    {...props}
  />
)

SizeBoxSmall.propTypes = {
  as: PropTypes.elementType,
  className: PropTypes.string,
  selected: PropTypes.bool,
}

export const Size = ({ as: Component = "div", ...props }) => (
  <Component className="flex flex-nowrap" {...props} />
)

Size.propTypes = { as: PropTypes.elementType }

export const SizeContainer = forwardRef((props, ref) => (
  // CHECK KONAM
  <div className="px-15 basis-auto py-8 text-center" ref={ref} {...props} />
))

SizeContainer.displayName = "SizeContainer"
